module.exports = __webpack_public_path__ + "img/JulieCherrington.96f4fbd2.jpg";